import { MessageDescriptor } from 'react-intl';

export enum IssueStageSize {
  small = 'small',
  default = 'default',
  issueCard = 'issueCard',
}

export type StatusFormatter = (descriptor: MessageDescriptor) => string;

export interface IssueStageProps {
  stageId: string;
  workflowId?: string;
  issueArchived: boolean;
  size?: IssueStageSize;
}
